import { coreState, coreMutations, coreActions } from '~/marketplace-front-core/store/auth'

export const state = coreState

export const mutations = coreMutations

export const actions = coreActions
